import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import envConfig from '../../../config';
import { request } from '../../../common/util/RestClient';
import {
  createUserMappingValues,
  fetchCommunicationUserMappingValues,
  fetchCommunicationUsers,
} from '../../routines/integrations/communicationRoutines';
import {
  COMMUNICATION_CRITERIA,
  COMMUNICATION_DEDUPLICATION_MAPPING,
  COMMUNICATION_FIELD_MAPPING_TYPE,
  ENTITY_LEVEL,
} from '../../../common/constants/integrationConstants/communicationConstants';
import { capitalizeFirstLetter } from '../../../common/util/commonUtil';

function* fetchCommunicationUsersSaga(action) {
  try {
    const { vendor } = action.payload;
    const URL = `${envConfig.APIG_URL}${vendor}/users`;
    const { data } = yield call(request, URL);
    yield put(fetchCommunicationUsers.success(data));
  } catch (error) {
    yield put(fetchCommunicationUsers.failure({ error }));
  }
}

function* fetchCommunicationUserMappingValuesSaga(action) {
  try {
    const { vendor, type } = action.payload;
    const URL = `${envConfig.APIG_URL}field-mapping/user/field-mapping-values?type=${type}&vendor=${vendor}`;
    const { data } = yield call(request, URL);
    yield put(fetchCommunicationUserMappingValues.success(data));
  } catch (error) {
    yield put(fetchCommunicationUserMappingValues.failure({ error }));
  }
}

function* saveCommunicationUserMappingValuesSaga(action) {
  try {
    const { vendor, type, mappingValues } = action.payload;
    const url = `${envConfig.APIG_URL}field-mapping/user?vendor=${vendor}&type=${type}`;
    const config = {
      method: 'POST',
      payload: {
        mappingValues,
        entity: ENTITY_LEVEL.USER,
        criteria: COMMUNICATION_CRITERIA,
        fieldMappingType: COMMUNICATION_FIELD_MAPPING_TYPE,
        velarisFieldId: COMMUNICATION_DEDUPLICATION_MAPPING.velarisFieldId,
        vendorFieldId: COMMUNICATION_DEDUPLICATION_MAPPING.vendorFieldId,
      },
    };

    const { data } = yield call(request, url, config);
    yield put(
      createUserMappingValues.success({
        mappingValues: data.mappingValues,
        successMessage: `${capitalizeFirstLetter(
          vendor
        )} configuration successfully saved`,
      })
    );
  } catch (error) {
    yield put(createUserMappingValues.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchCommunicationUsers.TRIGGER, fetchCommunicationUsersSaga),
    takeLatest(
      fetchCommunicationUserMappingValues.TRIGGER,
      fetchCommunicationUserMappingValuesSaga
    ),
    takeLatest(
      createUserMappingValues.TRIGGER,
      saveCommunicationUserMappingValuesSaga
    ),
  ]);
}
